import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "loader-container" }
const _hoisted_2 = { class: "app-loader" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _renderSlot(_ctx.$slots, "default", {}, undefined, true),
    _withDirectives(_createElementVNode("div", _hoisted_2, _cache[0] || (_cache[0] = [
      _createStaticVNode("<div class=\"app-loader-animation\" data-v-c6a2a6b0><div class=\"app-loader-animation-inner animation-one\" data-v-c6a2a6b0></div><div class=\"app-loader-animation-inner animation-two\" data-v-c6a2a6b0></div><div class=\"app-loader-animation-inner animation-three\" data-v-c6a2a6b0></div></div><span class=\"app-loading-text\" data-v-c6a2a6b0>Loading ....</span>", 2)
    ]), 512), [
      [_vShow, _ctx.isLoading]
    ])
  ]))
}